var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 96.5L22.4868 138.759V54.2414L0 96.5Z",
    fill: "#FF5000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9934 192.5L138.249 170.011H53.7378L95.9934 192.5Z",
    fill: "#FF5000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192 96.5L169.5 54.2414V138.759L192 96.5Z",
    fill: "#FF5000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0061 0.5L53.7372 22.9884H138.262L96.0061 0.5Z",
    fill: "#FF5000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.851 9.10541L56.2031 76.2126V119.399H85.3193V151.143L133.727 97.1629H105.022L182.851 9.10541Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logoMini.57c51d2f151d1c9824847b6eaf741b1d.svg";
export { ForwardRef as ReactComponent };